import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import useSWR from 'swr';
import { CustomersProjectsDataGrid } from '../../components/datagrid/CustomersProjectsDataGrid';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { Unit } from '../../types/unit.types';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { swrConfig } from '../Assets/AssetsEdit';

export function CustomersProjects() {
  const history = useHistory();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'Customers projects',
      steps: [{ name: 'Home', pathToCutCount: 1 }],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const { data, error } = useSWR<Unit[]>(
    `${API_URL.CUSTOMER_PROJECT_LIST_FILTERED}?visibleOnly=false&includeElapsedTime=true`,
    fetcher,
    swrConfig,
  );

  const handleEditButton = (e): void => {
    history.push(`/customers-projects/edit/${e.row.data.id}`);
  };

  return (
    <PageContentWrapper error={error} loading={!data}>
      <CustomersProjectsDataGrid data={data} handleEdit={handleEditButton} />
    </PageContentWrapper>
  );
}
export default CustomersProjects;
